import React from 'react'

const Temperature = () => {
    return (
        <div className="temperature">
            <h3 className="temperature-h3">
                Temperature controlled vehicle
            </h3>
            <p className="tempretaure-p">
                940 air offers total logistics solution to maintain the cold chain which requires 
                temperature controlled conditions during transport.
                From fresh cut flowers, horticultural produce, khatt to sensitive medical and pharmaceutical 
                shipments, we possess the necessary knowledge to assure the safe delivery of your cargo.
            </p>
        </div>
    )
}

export default Temperature
